import * as queryKeys from "@/data/constant/queryKeys";
import { request } from "@/util/api";
import { useQuery } from "@tanstack/react-query";

const useForwarderData = (search?: any, enabled?: boolean) => {
  return useQuery<any[]>({
    queryKey: [queryKeys.FORWARDER_DATA, search],
    queryFn: () =>
      request({
        method: "GET",
        url: `/forwarder/lookup`,
        params: search,
      }),
    enabled: enabled,
  });
};

export default useForwarderData;
